import { ProductionTypes } from '@shared/utils/app-config';

export const environment = {
  production: true,
  productionType: ProductionTypes.isIndustrialCam,
  baseApiUrl: 'https://api.industrial.video/',
  baseNewApiUrl: '',
  translations: {
    en: '/assets/translations/industrial-cam/en.json',
  },
  applicationInsights: {
    instrumentationKey: '81ec4a39-4936-4a32-826b-a9859f796c13',
  },
  googleMaps: {
    apiKey: 'industrialCam_GoogleMapsApiKey',
  },
  statics: {
    logo: '',
    background: '',
    favicon: './assets/images/iCamLogo.svg',
    blueLogo: './assets/images/iCamLogo.svg',
    downloadLink: 'https://download.industrial.video/prod-installer/Setup.exe',
    userDefaultUploadImage: './assets/images/user140.svg',
    noPreviewAvailable: './assets/images/no-preview-available.png',
    unlabeledEvidence: './assets/images/unlabeled_evidence.svg',
    evidenceLabeling: './assets/images/evidence_labeling.svg',
    zoomIn: './assets/images/zoomIn.png',
    zoomOut: './assets/images/zoomOut.png',
    rotatecw: './assets/images/rotatecw.png',
    rotateaw: './assets/images/rotateaw.png',
    closeGalleryIcon: './assets/images/close-gallery-icon.png',
  },
  b2cConfig: {
    clientId: 'b67475de-7b1e-417a-9a86-2c10d65d1004',
    authority: 'https://icvprod.ciamlogin.com/icvprod.onmicrosoft.com',
    redirectUri: 'https://app.industrial.video',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: true,
    b2cApiScope: 'api://01fddd0a-2f75-4803-b1e8-b772935a0e0b/IndustrialCam.FullAccess',
    b2cNewApiScope: 'api://01fddd0a-2f75-4803-b1e8-b772935a0e0b/IndustrialCam.FullAccess',
    b2cScopes: ['openid', 'offline_access', 'profile', 'email'],
    knownAuthorities: 'icvprod.ciamlogin.com',
  },
  tracking: {
    analyticsId: null,
    clarityId: null,
  },
};
